export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20film%20strip%20silhouettes%20and%20soft%20golden%20bokeh%20lighting%20on%20dark%20backdrop%2C%20elegant%20movie%20theater%20atmosphere%20with%20subtle%20red%20and%20amber%20tones%2C%20artistic%20depth%20of%20field%2C%20luxurious%20texture%2C%20sophisticated%20dramatic%20mood&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
          alt="老子影视网 - 高清影视在线观影平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs font-medium tracking-wider mb-5 whitespace-nowrap">
              高清影视 · 免费在线
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              老子影视网
              <span className="block text-xl md:text-3xl lg:text-4xl text-accent-300 mt-1">
                超清不缓冲 · 秒开畅享
              </span>
            </h1>

            <p className="text-base md:text-lg text-white/70 font-heading mb-6">
              海量高清电影电视剧，全集播放，观影从未如此简单
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              老子影视网汇聚全网高清电影、高清电视剧资源，覆盖动作、喜剧、悬疑、爱情、科幻等全类型片库。
              每日持续更新热播剧集与院线大片，超清画质秒开不缓冲，无需注册即可免费在线观看全集。
              无论经典回顾还是追新热播，这里都是你的一站式高清视频观影平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-300">10万+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-300">4K</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">超清画质</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-300">7×24</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">持续更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                开始观影
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none hidden lg:block">
            <div className="relative">
              <div className="aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20movie%20poster%20collage%20with%20warm%20cinematic%20lighting%2C%20film%20reels%20and%20clapperboard%20elements%2C%20golden%20and%20crimson%20color%20scheme%2C%20dramatic%20theatrical%20atmosphere%2C%20elegant%20composition%20with%20soft%20gradients&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                  alt="高清电影电视剧精选推荐"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-2 -right-2 bg-background-50 rounded-lg px-4 py-3 border border-background-200/60">
                <div className="text-xs text-foreground-500">今日更新</div>
                <div className="text-lg font-bold text-primary-500">68 部</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}